export const FETCH_COMPANIES_REQUEST = 'FETCH_COMPANIES_REQUEST';
export const FETCH_COMPANIES_SUCCESS = 'FETCH_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_FAIL = 'FETCH_COMPANIES_FAIL';

export const FETCH_COMPANY_DETAIL_REQUEST = 'FETCH_COMPANY_DETAIL_REQUEST';
export const FETCH_COMPANY_DETAIL_SUCCESS = 'FETCH_COMPANY_DETAIL_SUCCESS';
export const FETCH_COMPANY_DETAIL_FAIL = 'FETCH_COMPANY_DETAIL_FAIL';

export const FETCH_COMPANY_PROFILE_REQUEST = 'FETCH_COMPANY_PROFILE_REQUEST';
export const FETCH_COMPANY_PROFILE_SUCCESS = 'FETCH_COMPANY_PROFILE_SUCCESS';
export const FETCH_COMPANY_PROFILE_FAIL = 'FETCH_COMPANY_PROFILE_FAIL';

export const CREATE_COMPANY_REQUEST = 'CREATE_COMPANY_REQUEST';
export const CREATE_COMPANY_SUCCESS = 'CREATE_COMPANY_SUCCESS';
export const CREATE_COMPANY_FAIL = 'CREATE_COMPANY_FAIL';

export const UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_FAIL = 'UPDATE_COMPANY_FAIL';

export const UPDATE_COMPANY_PROFILE_REQUEST = 'UPDATE_COMPANY_PROFILE_REQUEST';
export const UPDATE_COMPANY_PROFILE_SUCCESS = 'UPDATE_COMPANY_PROFILE_SUCCESS';
export const UPDATE_COMPANY_PROFILE_FAIL = 'UPDATE_COMPANY_PROFILE_FAIL';

export const ACCEPT_COMPANY_PERMISSION_BY_OWNER_REQUEST =
  'ACCEPT_COMPANY_PERMISSION_BY_OWNER_REQUEST';
export const ACCEPT_COMPANY_PERMISSION_BY_OWNER_SUCCESS =
  'ACCEPT_COMPANY_PERMISSION_BY_OWNER_SUCCESS';
export const ACCEPT_COMPANY_PERMISSION_BY_OWNER_FAIL =
  'ACCEPT_COMPANY_PERMISSION_BY_OWNER_FAIL';

export const DECLINE_COMPANY_PERMISSION_BY_OWNER_REQUEST =
  'DECLINE_COMPANY_PERMISSION_BY_OWNER_REQUEST';
export const DECLINE_COMPANY_PERMISSION_BY_OWNER_SUCCESS =
  'DECLINE_COMPANY_PERMISSION_BY_OWNER_SUCCESS';
export const DECLINE_COMPANY_PERMISSION_BY_OWNER_FAIL =
  'DECLINE_COMPANY_PERMISSION_BY_OWNER_FAIL';

export const FETCH_COMPANY_TYPE_REQUEST = 'FETCH_COMPANY_TYPE_REQUEST';
export const FETCH_COMPANY_TYPE_SUCCESS = 'FETCH_COMPANY_TYPE_SUCCESS';
export const FETCH_COMPANY_TYPE_FAIL = 'FETCH_COMPANY_TYPE_FAIL';

export const FETCH_BUSINESS_TYPE_REQUEST = 'FETCH_BUSINESS_TYPE_REQUEST';
export const FETCH_BUSINESS_TYPE_SUCCESS = 'FETCH_BUSINESS_TYPE_SUCCESS';
export const FETCH_BUSINESS_TYPE_FAIL = 'FETCH_BUSINESS_TYPE_FAIL';

export const REGISTER_SILA_COMPANY = 'REGISTER_SILA_COMPANY';
export const REGISTER_SILA_COMPANY_SUCCESS = 'REGISTER_SILA_COMPANY_SUCCESS';
export const REGISTER_SILA_COMPANY_FAIL = 'REGISTER_SILA_COMPANY_FAIL';
export const REGISTER_SILA_COMPANY_CANCEL = 'REGISTER_SILA_COMPANY_CANCEL';

export const UPDATE_SILA_COMPANY = 'UPDATE_SILA_COMPANY';
export const UPDATE_SILA_COMPANY_SUCCESS = 'UPDATE_SILA_COMPANY_SUCCESS';
export const UPDATE_SILA_COMPANY_FAIL = 'UPDATE_SILA_COMPANY_FAIL';
export const UPDATE_SILA_COMPANY_CANCEL = 'UPDATE_SILA_COMPANY_CANCEL';

export const POST_COMPANY_REQUEST_KYB = 'POST_COMPANY_REQUEST_KYB';
export const POST_COMPANY_REQUEST_KYB_SUCCESS =
  'POST_COMPANY_REQUEST_KYB_SUCCESS';
export const POST_COMPANY_REQUEST_KYB_FAIL = 'POST_COMPANY_REQUEST_KYB_FAIL';
export const POST_COMPANY_REQUEST_KYB_CANCEL =
  'POST_COMPANY_REQUEST_KYB_CANCEL';

export const GET_COMPANY_WALLET = 'GET_COMPANY_WALLET';
export const GET_COMPANY_WALLET_SUCCESS = 'GET_COMPANY_WALLET_SUCCESS';
export const GET_COMPANY_WALLET_FAIL = 'GET_COMPANY_WALLET_FAIL';

export const GET_COMPANY_SILA_VERIFICATION = 'GET_COMPANY_SILA_VERIFICATION';
export const GET_COMPANY_SILA_VERIFICATION_SUCCESS =
  'GET_COMPANY_SILA_VERIFICATION_SUCCESS';
export const GET_COMPANY_SILA_VERIFICATION_FAIL =
  'GET_COMPANY_SILA_VERIFICATION_FAIL';
export const GET_COMPANY_SILA_VERIFICATION_INTERVAL =
  'GET_COMPANY_SILA_VERIFICATION_INTERVAL';

export const GET_SILA_COMPANY = 'GET_SILA_COMPANY';
export const GET_SILA_COMPANY_SUCCESS = 'GET_SILA_COMPANY_SUCCESS';
export const GET_SILA_COMPANY_FAIL = 'GET_SILA_COMPANY_FAIL';

export const UPLOAD_KYB_DOCUMENT_REQUEST = 'UPLOAD_KYB_DOCUMENT_REQUEST';
export const UPLOAD_KYB_DOCUMENT_SUCCESS = 'UPLOAD_KYB_DOCUMENT_SUCCESS';
export const UPLOAD_KYB_DOCUMENT_FAIL = 'UPLOAD_KYB_DOCUMENT_FAIL';

//Get plaid link company token
export const GET_PLAID_LINK_COMPANY_TOKEN_REQUEST =
  'GET_PLAID_LINK_COMPANY_TOKEN_REQUEST';
export const GET_PLAID_LINK_COMPANY_TOKEN_SUCCESS =
  'GET_PLAID_LINK_COMPANY_TOKEN_SUCCESS';
export const GET_PLAID_LINK_COMPANY_TOKEN_FAIL =
  'GET_PLAID_LINK_COMPANY_TOKEN_FAIL';
export const PLAID_LINK_COMPANY_ACCOUNT_CONNECTED =
  'PLAID_LINK_COMPANY_ACCOUNT_CONNECTED';

//Get plaid company account
export const GET_PLAID_COMPANY_ACCOUNT_REQUEST =
  'GET_PLAID_COMPANY_ACCOUNT_REQUEST';
export const GET_PLAID_COMPANY_ACCOUNT_SUCCESS =
  'GET_PLAID_COMPANY_ACCOUNT_SUCCESS';
export const GET_PLAID_COMPANY_ACCOUNT_FAIL = 'GET_PLAID_COMPANY_ACCOUNT_FAIL';

export const GET_COMPANY_PLAID_VERIFY_ACCOUNT_REQUEST =
  'GET_COMPANY_PLAID_VERIFY_ACCOUNT_REQUEST';

export const GET_COMPANY_PLAID_VERIFY_ACCOUNT_SUCCESS =
  'GET_COMPANY_PLAID_VERIFY_ACCOUNT_SUCCESS';

export const GET_COMPANY_PLAID_VERIFY_ACCOUNT_FAIL =
  'GET_COMPANY_PLAID_VERIFY_ACCOUNT_FAIL';

export const REMOVE_PLAID_COMPANY_ACCOUNT = 'REMOVE_PLAID_COMPANY_ACCOUNT';
export const REMOVE_PLAID_COMPANY_ACCOUNT_SUCCESS =
  'REMOVE_PLAID_COMPANY_ACCOUNT_SUCCESS';
export const REMOVE_PLAID_COMPANY_ACCOUNT_FAIL =
  'REMOVE_PLAID_COMPANY_ACCOUNT_FAIL';

export const FETCHING_COMPANY_WALLET_BAL_REQUEST =
  'FETCHING_COMPANY_WALLET_BAL_REQUEST';
export const FETCHING_COMPANY_WALLET_BAL_SUCCESS =
  'FETCHING_COMPANY_WALLET_BAL_SUCCESS';
export const FETCHING_COMPANY_WALLET_BAL_FAIL =
  'FETCHING_COMPANY_WALLET_BAL_FAIL';
export const FETCHED_COMPANY_WALLET_BAL_RESET =
  'FETCHED_COMPANY_WALLET_BAL_RESET';

export const DELETE_COMPANY_ACCOUNT_REQUEST = 'DELETE_COMPANY_ACCOUNT_REQUEST';
export const DELETE_COMPANY_ACCOUNT_SUCCESS = 'DELETE_COMPANY_ACCOUNT_SUCCESS';
export const DELETE_COMPANY_ACCOUNT_FAIL = 'DELETE_COMPANY_ACCOUNT_FAIL';
export const DELETE_COMPANY_ACCOUNT_RESET = 'DELETE_COMPANY_ACCOUNT_RESET';

export const TOGGLE_WALLET_NOT_SET_MODAL = 'TOGGLE_WALLET_NOT_SET_MODAL';

export const SET_COMPANY_PAYMENT_PLAN_REQUEST =
  'SET_COMPANY_PAYMENT_PLAN_REQUEST';
export const SET_COMPANY_PAYMENT_PLAN_SUCCESS =
  'SET_COMPANY_PAYMENT_PLAN_SUCCESS';
export const SET_COMPANY_PAYMENT_PLAN_FAIL = 'SET_COMPANY_PAYMENT_PLAN_FAIL';

export const REGISTER_COMPANY = 'REGISTER_COMPANY';
export const CLEAR_COMPANY = 'CLEAR_COMPANY';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';

export const SET_COMPANY_PLAID_CONNECTION_FAILED =
  'SET_COMPANY_PLAID_CONNECTION_FAILED';

export const GET_ZEAL_LOGIN_URL_REQUEST = 'GET_ZEAL_LOGIN_URL_REQUEST';
export const GET_ZEAL_LOGIN_URL_SUCCESS = 'GET_ZEAL_LOGIN_URL_SUCCESS';
export const GET_ZEAL_LOGIN_URL_FAIL = 'GET_ZEAL_LOGIN_URL_FAIL';

export const TRIGGER_CREATE_COMPANY_MODAL = 'TRIGGER_CREATE_COMPANY_MODAL';
